import { Component, OnInit, OnDestroy, Injectable, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';
import { EventDetailComponent } from '../../events/detail/event-detail.component';
import { Router, ActivatedRoute, UrlSegment } from '@angular/router';
import { DataView } from 'primeng/dataview';
//import moment from 'moment-es6';
import { MomentService } from '../../shared/moment/moment.service';

import { NotificationService, DialogService, PagedResult, PagedSearch, DatagridService, UtilService } from '../../shared/index'; //app/shared/index barrel;
import { EventsService } from '../../events/shared/events.service';
import { BusyIndicatorComponent } from '../../shared/widgets/busy-indicator/busy-indicator.component';
import { EventsContextSearchComponent } from '../search/context-search-input/events-context-search-input.component';
import { EventSearchParams } from '../search/event-search-params.model';
import { NavigationService } from '../../shared/navigation/navigation.service';
import { EventsNewComponent } from '../new/events-new.component';
import { EventTypeService } from '../shared/event-type/event-type.service';
import {
  WlEventsToolbarBroadcastService,
  WlEventsToolbarEventTypeEnum,
  WlEventsToolbarEvent,
} from '../../shared/container/toolbars/module/events/broadcast/index';
import { ConfigService } from 'src/app/config/shared/config.service';

@Component({
  selector: 'wl-events-dashboard',
  templateUrl: 'events-dashboard.component.html',
  styleUrls: ['events-dashboard.component.css'],
  providers: [EventsService],
    standalone: false
})
@Injectable()
export class EventsDashboardComponent implements OnInit, OnDestroy {
  @ViewChild('upcomingEventsDataGrid', { static: false }) public upcomingEventsDataGrid: DataView;
  @ViewChild('newEventDialog', { static: false }) newEventDialog: EventsNewComponent;

  public static _lastSearch: string = '';

  public _dialogService: DialogService;
  public _router: Router;
  public _eventsService: EventsService;
  public _dataGridService: DatagridService;
  public _utilService: UtilService;
  public _configService: ConfigService;

  private _momentService: MomentService;

  public _lastSearchParams: any;
  public _dataIntiallyLoaded: boolean;
  public _route: ActivatedRoute;
  public _eventTypes: Array<string> = [];
  public _subscriptions: Array<Subscription> = [];
  public _exporting: boolean = false;
  public _exportEmpty: boolean = false;
  public _error: string = '';

  public errorMessage: string;
  public upcomingEvents: PagedResult;
  public searchParams: EventSearchParams;
  public isSearching: boolean;
  public _resumeSearchIntially: boolean = false;

  public constructor(
    router: Router,
    route: ActivatedRoute,
    dialogService: DialogService,
    eventsService: EventsService,
    dataGridService: DatagridService,
    utilService: UtilService,
    momentService: MomentService,
    configService: ConfigService,
    public _navigationService: NavigationService,
    public _eventToolbarBroadcastService: WlEventsToolbarBroadcastService,
    public _eventTypeService: EventTypeService
  ) {
    this._configService = configService;
    this._dialogService = dialogService;
    this._router = router;
    this._eventsService = eventsService;
    this._dataGridService = dataGridService;
    this._utilService = utilService;
    this._dataIntiallyLoaded = false;
    this._route = route;
    this._momentService = momentService;

    this.upcomingEvents = new PagedResult();
    this.errorMessage = '';

    let storedSearchParams = this.getStoredSearchParameters();

    if (storedSearchParams) {
      this.searchParams = storedSearchParams;
      // simple JSON object with the date coming back as a string. Create a new date here.
      this.searchParams.SearchDateBegin = new Date(storedSearchParams.SearchDateBegin);
      this.searchParams.SearchDateEnd = new Date(storedSearchParams.SearchDateEnd);
      this._resumeSearchIntially = true;
    } else {
      this.searchParams = new EventSearchParams();
      this.searchParams.SearchDateBegin = this._momentService.getMoment().startOf('day').toDate();
      this.searchParams.SearchDateEnd = this._momentService.getMoment().add(1, 'years').startOf('day').toDate();
      this.searchParams.PageNumber = 1;
      this.searchParams.PageSize = 10;
    }

    this.isSearching = false;

    this._lastSearchParams = null;
  }

  async ngOnInit() {
    let v4Redirect = await this._configService.hasBetaFeatureEnabled('EventsV4');
    if (v4Redirect) {
      this._router.navigate(['events-v4']);
    }
    this._eventTypeService.getEventTypes().then((data: Array<string>) => {
      this._eventTypes = data;
    });

    this._route.url.subscribe((data: Array<UrlSegment>) => {
      for (let seg of data) {
        if (this._utilService.toLowerTrim(seg.path) == 'new') {
          //directly open the new dialog
          setTimeout(() => this.newEvent(), 500);
        }
      }
    });

    // watch for passed in query params
    this._subscriptions.push(
      this._route.queryParams.subscribe((params: any) => {
        if (params) {
          if (!this._resumeSearchIntially) this.searchParams.Keyword = params.q;
          this.search();
        }
      })
    );

    // watch for if the tool bar reset button was pressed
    this._subscriptions.push(
      this._eventToolbarBroadcastService.subscribe((toolbarEvent) => {
        if (toolbarEvent.type == WlEventsToolbarEventTypeEnum.clearKeyword) {
          this.resetForm();
          this.search();
        } else if (toolbarEvent.type == WlEventsToolbarEventTypeEnum.requestKeywordAnswer) {
          this.searchParams.Keyword = toolbarEvent.data;
          this._search();
        }
      })
    );

    // if coming back from somewhere else, resume the search where they left off
    if (this._resumeSearchIntially) setTimeout(() => this.resumeSearch());
  }

  /**
   * clean up
   */
  ngOnDestroy(): void {
    if (this._subscriptions) this._subscriptions.forEach((s) => s.unsubscribe());

    // ensure everyone watching that we're no longer searching
    this._eventToolbarBroadcastService.broadcast(new WlEventsToolbarEvent(WlEventsToolbarEventTypeEnum.searching, false));
  }

  public loadEvents = (paging?: any): Promise<any> => {
    this.isSearching = true;
    this.searchParams.OrderBy = 'StartDateTimeUTC:asc';
    this._eventToolbarBroadcastService.broadcast(new WlEventsToolbarEvent(WlEventsToolbarEventTypeEnum.searching, true));

    if (paging) {
      this.searchParams.PageNumber = paging.PageNumber;
      this.searchParams.PageSize = paging.PageSize;
    }
    this.searchParams.PageNumber = Math.max(1, this.searchParams.PageNumber);

    this._resumeSearchIntially = false;

    // save search parameters in case they leave and come back
    this.storeSearchParameters(this.searchParams);

    return this._eventsService.searchEvents(this.searchParams).then(
      (data: any) => {
        this.isSearching = false;
        this.upcomingEvents = data;
        this._eventToolbarBroadcastService.broadcast(new WlEventsToolbarEvent(WlEventsToolbarEventTypeEnum.searching, false));
      },
      (error: any) => {
        this.isSearching = false;
        this._dialogService.error(error);
        this._eventToolbarBroadcastService.broadcast(new WlEventsToolbarEvent(WlEventsToolbarEventTypeEnum.searching, false));
      }
    );
  };

  public lazyLoad($event: any): void {
    // don't let the grid load first if user is coming back to the page
    if (!this._resumeSearchIntially) this.loadEvents({ PageNumber: $event.first / Math.max(1, $event.rows) + 1, PageSize: $event.rows });
  }

  public searchChanged = (newSearchParams: any): void => {
    this.searchParams = newSearchParams;
    this.loadEvents();
  };

  public _search(): void {
    (<any>this.upcomingEventsDataGrid).first = 0;
    //this.upcomingEventsDataGrid.updatePaginator();
    this.searchParams.PageNumber = 1;
    this.searchParams.PageSize = 10;
    this.loadEvents();
  }

  /**
   * initialize a new search
   */
  public search(): void {
    // need keyword
    this._eventToolbarBroadcastService.broadcast(new WlEventsToolbarEvent(WlEventsToolbarEventTypeEnum.requestKeyword));
  }

  /**
   * initialize a search
   */
  public resumeSearch(): void {
    // set the grid's paginator to the save page number
    (<any>this.upcomingEventsDataGrid).first = (this.searchParams.PageNumber - 1) * this.upcomingEventsDataGrid.rows;
    //this.upcomingEventsDataGrid.updatePaginator();
    this.loadEvents();
  }

  /**
   * start an export of the current search, unpaged
   */
  public export(): void {
    if (this._exporting) return;

    this._exporting = true;
    this._exportEmpty = false;
    this._error = '';
    this._eventsService.getEventsExport(this.searchParams).then(
      (url) => {
        this._exporting = false;
        if (url) this._navigationService.popupSafeNavigate(url);
        else this._exportEmpty = true;
      },
      (error) => {
        this._exporting = false;
        this._error = this._utilService.extractErrorMessage(error);
      }
    );
  }

  /**
   * rest form to default
   */
  public resetForm(): void {
    this.searchParams.Keyword = '';
    this.searchParams.EventType = null;
    this.searchParams.OrganizationEvent = this.searchParams.InternalEvent = this.searchParams.MembersOnlyEvent = true;
    this.searchParams.CommunityEvent = false;
    this.searchParams.EventsWithPendingRegistrationsOnly = false;
    this.searchParams.SearchDateBegin = this._momentService.getMoment().startOf('day').toDate();
    this.searchParams.SearchDateEnd = this._momentService.getMoment().add(1, 'years').startOf('day').toDate();
  }

  public handleSearchSubmit(event?: any): void {
    this.search();
  }

  public gotoEvent(eventId: number): void {
    this._navigationService.navigateToEvent(eventId);
  }

  public gotoEventSettings(eventId: number): void {
    this._navigationService.navigateToEventSettings(eventId);
  }

  public newEvent = (): void => {
    this.newEventDialog.reset();
    this.newEventDialog.open();
  };

  /**
   * store given search parameters
   */
  public storeSearchParameters(searchParamsToSave: EventSearchParams): void {
    EventsDashboardComponent._lastSearch = JSON.stringify(searchParamsToSave);
  }

  /**
   * get stored search parameters
   */
  public getStoredSearchParameters(): EventSearchParams {
    if (!EventsDashboardComponent._lastSearch) return null;

    let reconstitutedSearchParams: EventSearchParams = null;

    try {
      reconstitutedSearchParams = JSON.parse(EventsDashboardComponent._lastSearch);

      if (reconstitutedSearchParams.SearchDateBegin && typeof reconstitutedSearchParams.SearchDateBegin == 'string')
        reconstitutedSearchParams.SearchDateBegin = this._momentService.getMomentByDate(reconstitutedSearchParams.SearchDateBegin).toDate();
      if (reconstitutedSearchParams.SearchDateEnd && typeof reconstitutedSearchParams.SearchDateEnd == 'string')
        reconstitutedSearchParams.SearchDateEnd = this._momentService.getMomentByDate(reconstitutedSearchParams.SearchDateEnd).toDate();

      return reconstitutedSearchParams;
    } catch (e) {
      // shut upuh you face
    }

    return reconstitutedSearchParams;
  }
}
